import React, { useEffect, useState, useMemo } from 'react'
import Modal from 'meinian-package/src/component/modal'
import moment from 'moment'
import { serialNum, targetCategory } from 'view/common'
import { taskStatusEnum } from 'view/common/taskEnum'
import { request } from 'meinian-package/src/utils'
import Button from 'meinian-package/src/baseComponent/button'
import * as userAuth from 'meinian-package/src/utils/auth'
import styles from './index.module.less'

export default ({ visible, taskItem, auth, footer = false, tab, onEnd, onEdit, onDelete, onClose }) => {
  const [taskData, setTaskData] = useState({})

  useEffect(() => {
    if (taskItem?.missionId) {
      request.get('/zhikuan/ins/blog/mission/get-mission-info', { params: { missionId: taskItem?.missionId } }).then(result => {
        setTaskData(result)
      })
    } else {
      setTaskData(taskItem)
    }
  }, [taskItem])

  const _footer = useMemo(() => {
    if (footer) {
      if (userAuth.isPermissions(auth, ['F18']) || userAuth.isPermissions(auth, ['F19']) || userAuth.isPermissions(auth, ['F20'])) {
        const termination = userAuth.isPermissions(auth, ['F18']) && <Button
          type="normal"
          onClick={() => {
            onEnd(taskData)
            onClose?.()
          }}
          style={{ marginRight: 8, width: 88 }}
        >终止</Button>
        const modify = userAuth.isPermissions(auth, ['F19']) && <Button
          type="normal"
          onClick={() => {
            onEdit(taskData)
            onClose?.()
          }}
          style={{ marginRight: 8, width: 88 }}
        >修改</Button>
        const deleteDom = userAuth.isPermissions(auth, ['F20'])
        && <Button
          type="normal"
          onClick={() => {
            onDelete(taskData)
            onClose?.()
          }}
          style={{ marginRight: 8, width: 88 }}
        >删除</Button>

        return <div>
          {
              tab === 'closed' ? deleteDom : <>
                {termination}
                {modify}
                {deleteDom}
              </>
            }
        </div>
      }
    } else {
      return null
    }
  }, [auth, footer, taskData, tab])

  return <Modal
    visible={visible}
    onClose={onClose}
    className={styles['task-detail-modal']}
    style={{ width: '480px' }}
    footer={_footer}
    title={<div className={styles['task-detail-title']}>
      <div>任务详情</div>
      <div className="task-detail-sub-title">{taskStatusEnum[taskData.missionStatus]}</div>
    </div>}
  >
    <div className={styles['task-detail-content']}>
      <div className="task-detail-content-item">
        <div className="title">任务名称</div>
        <div
          className="text"
          style={{
            fontWeight: '600',
            color: 'var(--m-text-1)'
          }}
        >{taskData.missionName}</div>
      </div>
      <div className="task-detail-content-item">
        <div className="title">创建者</div>
        <div className="text">{taskData.userName}</div>
      </div>
      <div className="task-detail-content-item">
        <div className="title">创建时间</div>
        <div className="text">{moment(taskData.createdAt).format('YYYY/MM/DD')}</div>
      </div>
      <div className="task-detail-content-item">
        <div className="title">任务周期</div>
        <div className="text">{moment(taskData.startTime).format('YYYY/MM/DD')}-{moment(taskItem.endTime).format('YYYY/MM/DD')} </div>
      </div>
      {
        taskData?.missionTargetList?.map((item, i) => <div className="task-detail-content-item" key={item.id}>
          <div className="title">任务目标</div>
          <div className="text">
            <div className="task-list-item">
              <div className="task-title">任务{serialNum(i)}</div>
              <div className="task-target-item df">
                <div className="label">目标品类</div>
                <div className="value">{targetCategory(item.gender, item.rootCategory, item.category)}</div>
              </div>
              <div className="task-target-item df">
                <div className="label">目标数量</div>
                <div className="value">{item.targetNum}</div>
              </div>
              <div className="task-target-item df">
                <div className="label">指定成员</div>
                <div className="value">{item.targetUserNameList.length ? item.targetUserNameList.map((it) => `${it.nickName} `) : '不限'}</div>
              </div>
            </div>
          </div>
        </div>)
      }
    </div>
  </Modal>
}
